export interface LabelValueData {
  label: string;
  value?: string;
}

export enum SubmissionDetailsBasicSectionDisplayMode {
  Default = "default",
  Narrow = "narrow",
}
